import { Component, OnInit, ViewChild } from '@angular/core';
import { Factura } from 'src/app/Models/factura/factura';
import { Usuario } from 'src/app/Models/usuario/usuario';
import { AuthService } from 'src/app/Service/auth.service';
import { DataService } from 'src/app/Service/data.service';
import { NotifyService } from 'src/app/Service/notify.service';
import { InfoComponent } from '../../objects/info/info/info.component';
import { LoadingComponent } from '../../objects/loading/loading.component';
import { NothingComponent } from '../../objects/nothing/nothing.component';
import { AlertComponent } from '../../objects/alert/alert/alert.component';
import { DetalleFactura } from 'src/app/Models/factura/detallefactura/detalle-factura';

@Component({
  selector: 'app-venta-product-detallado',
  templateUrl: './venta-product-detallado.component.html',
  styleUrls: ['./venta-product-detallado.component.css']
})
export class VentaProductDetalladoComponent implements OnInit {
  @ViewChild(AlertComponent, null) alert: AlertComponent;
  @ViewChild(LoadingComponent, null) loading: LoadingComponent;
  @ViewChild(NothingComponent, null) public nothing: NothingComponent;
  @ViewChild(InfoComponent, null) info: InfoComponent;
  public usuario:Usuario=new Usuario();
  public detfactus:DetalleFactura[]=[];
  public pagventas:any;
  public sumacantidad:number = 0;
  public sumapreuni:number = 0;
  public sumatotal:number = 0;
  constructor(private data: DataService, private notify: NotifyService,private auth:AuthService) { }

  ngOnInit() {
    this.usuario = this.auth.getCurrentUser();
    this.GetData();
    
  }

  GetData(){
    this.loading.show('cargando datos');
    this.data.GetSimple(this.data.api.detfactura).subscribe(r => {
      if (r.length < 1) {
          console.log(r);
          this.detfactus=[];
      }else{
          console.log(r);
          this.detfactus=r;
          console.log("Resultado");
          console.log(this.detfactus);
          this.loading.hide();
      }
    }, e => { console.log(e); },()=>this.GetTotalVentas());
  }

  GetTotalVentas(){
    this.detfactus.forEach(detalle => {
      this.sumacantidad+= +detalle.cantidad
      this.sumapreuni+= +detalle.preuni
      this.sumatotal+= +detalle.impnetoct
    });

    console.log(this.sumacantidad);
    console.log(this.sumapreuni);
    console.log(this.sumatotal);
    
  }
}
